/* eslint-disable no-unused-vars */
import * as React from 'react';
import { styled } from '@linaria/react';

import { range } from '@/utils';

interface Props {
  title: string;
  setTitle: (title: string) => void;
}

function FruitsArray({ title, setTitle }: Props) {
  return (
    <Wrapper>
      {'{'}
      <Row>
        <Prefix>{'  title: '}</Prefix>
        <Input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        {','}
      </Row>
      <Row>
        <Prefix>{'  startsAt: '}</Prefix>
        <Value>"2023-05-29T16:00:00Z"</Value>
        {','}
      </Row>
      <Row>
        <Prefix>{'  duration: '}</Prefix>
        <Value>4</Value>
        {','}
      </Row>
      <Row>
        <Prefix>{'  confirmed: '}</Prefix>
        <Value>true</Value>
        {','}
      </Row>
      {'}'}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  white-space: pre-wrap;
  width: 350px;
  max-width: 80vw;
`;

const Row = styled.div`
  display: flex;
  align-items: baseline;
`;

const Prefix = styled.span`
  display: block;
  min-width: 8rem;
`;

const Input = styled.input`
  flex: 1;
  min-width: 0px;
  max-width: 200px;
  border: none;
  border-bottom: 2px solid black;
  background: transparent;
  font-family: var(--font-family-mono);
  padding: 4px 4px 0px 4px;
  outline-offset: 3px;
  background: hsl(0deg 0% 93%);
  border-radius: 2px;
`;

const Value = styled.span`
  font-weight: var(--font-weight-bold);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default FruitsArray;
